import { EmployeeViewFields } from '../models/EmployeeView';

export default {
  pageConfig: {
    name: 'Інтелліартсівці',
    label: 'Інтелліартсівці',
  },
  employeeStatusOptions: {
    ACTIVE: 'Активний',
    BENCH: 'Bench',
    MILITARY_LEAVE: 'Військова відпустка',
    MATERNITY_LEAVE: 'Декретна відпустка',
    SABBATICAL: 'Творча відпустка',
    COMPASSIONATE_LEAVE: 'Відпустка зі співчуття',
    PARENTAL_DAYS: 'Батьківські дні',
    REHIRED: 'Повторно найнятий',
    INACTIVE: 'Неактивний',
  },
  employeeInfo: {
    syncEmployees: {
      title: 'Синхронізувати користувачів на залежних сервісах'
    },
    insuranceBenefitReport: {
      title: 'Завантажити звіт про страхівку',
      downloadError: 'Не вдалося завантажити звіт про страхівку'
    }
  },
  employeeDetails: {
    pageConfig: {
      name: 'Деталі користувача',
    },
    profileSection: {
      title: 'Профіль',
      fullName: 'Прізвище та ім\'я',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      email: 'Пошта',
      dateOfBirth: 'Дата народження',
      careerStartDate: 'Початок кар\'єри',
      sex: 'Стать',
      status: 'Статус',
      tenure: 'Термін',
      tenureUnit: 'Років',
    },
    editDialog: {
      title: 'Редагувати користувача',
      editButton: 'Редагувати',
      save: 'Зберегти',
      cancel: 'Скасувати',
      none: 'Не вказано',
      sexOptions: {
        MALE: 'Чоловіча',
        FEMALE: 'Жіноча',
      },
      notifications: {
        updateSuccess: 'Користувача успішно оновлено',
        updateError: 'Не вдалося оновити користувача',
      },
    },
    statusHistorySection: {
      title: 'Історія статусів',
      createButton: 'Створити запис',
      columns: {
        startDate: { headerName: 'Дата початку' },
        endDate: { headerName: 'Дата завершення' },
        status: { headerName: 'Статус' },
        reasonId: { headerName: 'Причина' },
        changeReasonType: { headerName: 'Тип зміни' },
        outcome: { headerName: 'Результат' },
        comment: { headerName: 'Коментар' },
        actions: { headerName: 'Дії' },
      },
      deleteDialog: {
        title: 'Видалити запис історії статусів',
        description: 'Ви впевнені, що хочете видалити запис історії статусів {{status}} ({{startDate}} — {{endDate}})?',
        confirm: 'Видалити',
      },
    },
    editStatusHistoryDialog: {
      title: 'Редагувати запис історії статусів',
      createTitle: 'Створити запис історії статусів',
      editTitle: 'Редагувати запис історії статусів',
      startDate: 'Дата початку',
      endDate: 'Дата завершення',
      status: 'Статус',
      reasonId: 'Причина',
      changeReasonType: 'Тип зміни',
      startDateRequired: 'Дата початку обовʼязкова',
      endDateRequired: 'Дата завершення обовʼязкова',
      statusRequired: 'Статус обовʼязковий',
      reasonIdRequired: 'Причина обов\'язкова',
      endDateAfterStartDate: 'Дата завершення має бути не раніше дати початку',
      outcome: 'Результат',
      comment: 'Коментар',
      notifications: {
        createSuccess: 'Запис історії статусів успішно створено',
        createError: 'Не вдалося створити запис історії статусів',
        updateSuccess: 'Запис історії статусів успішно оновлено',
        updateError: 'Не вдалося оновити запис історії статусів',
        deleteSuccess: 'Запис історії статусів успішно видалено',
        deleteError: 'Не вдалося видалити запис історії статусів',
      },
    },
    employmentSection: {
      title: 'Зайнятість',
      editButton: 'Редагувати',
      startDate: 'Дата початку',
      endDate: 'Дата завершення',
      probationPeriodEndDate: 'Кінець випробувального терміну',
      reason: 'Причина',
      changeReasonType: 'Тип зміни',
      alumni: 'Алумні',
      exitDetails: 'Деталі виходу',
      noExitDetails: 'Деталі виходу відсутні',
      exitInterviewLink: 'Посилання на вихідне інтерв\'ю',
      noExitInterviewLink: 'Посилання на вихідне інтерв\'ю відсутнє',
      noData: 'Дані про зайнятість відсутні',
      notifications: {
        updateError: 'Не вдалося оновити період зайнятості',
      },
    },
  },
  benchPage: {
    pageConfig: {
      name: 'Лава',
      label: 'Лава',
    },
    filter: {
      from: 'Від',
      to: 'До',
      combine: 'Об\'єднати по користувачу',
    },
    columns: {
      employeeId: { headerName: 'ID користувача' },
      photo: { headerName: 'Фото' },
      firstName: { headerName: 'Ім\'я' },
      lastName: { headerName: 'Прізвище' },
      isOver: { headerName: 'Статус завершено' },
      startDate: { headerName: 'Дата початку' },
      endDate: { headerName: 'Дата завершення' },
      reason: { headerName: 'Причина' },
      changeReasonType: { headerName: 'Тип зміни' },
      outcome: { headerName: 'Результат' },
      comment: { headerName: 'Коментар' },
    },
  },
  leavesPage: {
    pageConfig: {
      name: 'Відпустки',
      label: 'Відпустки',
    },
    filter: {
      status: 'Статус',
      from: 'Від',
      to: 'До',
      combine: 'Об\'єднати по користувачу',
    },
    columns: {
      employeeId: { headerName: 'ID користувача' },
      photo: { headerName: 'Фото' },
      firstName: { headerName: 'Ім\'я' },
      lastName: { headerName: 'Прізвище' },
      isOver: { headerName: 'Статус завершено' },
      startDate: { headerName: 'Дата початку' },
      endDate: { headerName: 'Дата завершення' },
      reason: { headerName: 'Причина' },
      changeReasonType: { headerName: 'Тип зміни' },
      outcome: { headerName: 'Результат' },
      comment: { headerName: 'Коментар' },
    },
  },
  onboardingPage: {
    pageConfig: {
      name: 'Онбординг',
      label: 'Онбординг',
    },
  },
  offboardingPage: {
    pageConfig: {
      name: 'Офбординг',
      label: 'Офбординг',
    },
    addExit: 'Додати вихід',
    filter: {
      eventType: 'Подія',
      from: 'Від',
      to: 'До',
      eventTypeOptions: {
        JOINED: 'Приєднався',
        LEFT: 'Звільнився',
      },
    },
    columns: {
      employeeId: { headerName: 'ID користувача' },
      photo: { headerName: 'Фото' },
      firstName: { headerName: 'Ім\'я' },
      lastName: { headerName: 'Прізвище' },
      startDate: { headerName: 'Дата початку' },
      endDate: { headerName: 'Дата завершення' },
      probationPeriodEndDate: { headerName: 'Кінець випробувального терміну' },
      projects: { headerName: 'Проєкти' },
      tenure: { headerName: 'Стаж (роки)' },
      changeReason: { headerName: 'Причина виходу' },
      changeReasonType: { headerName: 'Тип виходу' },
      alumni: { headerName: 'Алюмні' },
      exitDetails: { headerName: 'Деталі виходу' },
      exitInterviewLink: { headerName: 'Посилання на вихідне інтерв\'ю' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      title: 'Редагувати період зайнятості',
      employeeId: 'Користувач',
      startDate: 'Дата початку',
      endDate: 'Дата завершення',
      probationPeriodEndDate: 'Кінець випробувального терміну',
      changeReasonId: 'Причина виходу',
      changeReasonType: 'Тип виходу',
      alumniId: 'Алюмні',
      exitDetails: 'Деталі виходу',
      exitInterviewLink: 'Посилання на вихідне інтерв\'ю',
      notifications: {
        updateSuccess: 'Період зайнятості успішно оновлено',
        updateError: 'Не вдалося оновити період зайнятості',
        noEmploymentPeriod: 'Для цього користувача не знайдено жодного трудового договору',
      },
    },
    cancelClosingDialog: {
      title: 'Скасувати закриття',
      description: 'Ви впевнені, що хочете скасувати закриття періоду зайнятості для "{{firstName}} {{lastName}}"? Це очистить деталі виходу.',
      confirm: 'Скасувати закриття',
    },
  },
  risksPage: {
    pageConfig: {
      name: 'Управління ризиками',
      label: 'Управління ризиками',
    },
    createButton: 'Створити ризик',
    columns: {
      id: { headerName: 'ID' },
      registrationDate: { headerName: 'Дата реєстрації' },
      employee: { headerName: 'Користувач' },
      lifecycleStage: { headerName: 'Стадія життєвого циклу' },
      riskLevel: { headerName: 'Рівень ризику' },
      riskType: { headerName: 'Тип ризику' },
      mainReasons: { headerName: 'Основні причини' },
      subReasons: { headerName: 'Додаткові причини' },
      teamExpectation: { headerName: 'Очікування команди' },
      cultureAlignment: { headerName: 'Відповідність культурі' },
      nextSteps: { headerName: 'Наступні кроки' },
      keyConcerns: { headerName: 'Ключові занепокоєння' },
      documentLink: { headerName: '1-1 з працівником' },
      resolutionDate: { headerName: 'Дата вирішення' },
      riskStatus: { headerName: 'Статус ризику' },
      resolutionOutcome: { headerName: 'Результат вирішення' },
      assignees: { headerName: 'Відповідальні' },
      comments: { headerName: 'Коментарі' },
      isExitCase: { headerName: 'Вихід' },
      employeeStatus: { headerName: 'Статус працівника' },
      projects: { headerName: 'Проєкти' },
      actions: { headerName: 'Дії' },
    },
    riskTypeOptions: {
      VOLUNTARY: 'Добровільно',
      INVOLUNTARY: 'Недобровільно',
    },
    editDialog: {
      createTitle: 'Створити ризик',
      editTitle: 'Редагувати ризик',
      fields: {
        registrationDate: 'Дата реєстрації',
        employeeId: 'Користувач',
        lifecycleStageId: 'Стадія життєвого циклу',
        riskLevelId: 'Рівень ризику',
        riskType: 'Тип ризику',
        mainReasonIds: 'Основні причини',
        subReasonIds: 'Додаткові причини',
        teamExpectationId: 'Очікування команди',
        cultureAlignmentId: 'Відповідність культурі',
        nextSteps: 'Наступні кроки',
        keyConcerns: 'Ключові занепокоєння',
        documentLink: '1-1 з працівником',
        resolutionDate: 'Дата вирішення',
        riskStatusId: 'Статус ризику',
        resolutionOutcomeId: 'Результат вирішення',
        assigneeIds: 'Відповідальні',
        comments: 'Коментарі',
        isExitCase: 'Вихід',
      },
      validation: {
        employeeRequired: 'Користувач обов\'язковий',
        registrationDateRequired: 'Дата реєстрації обов\'язкова',
        lifecycleStageRequired: 'Стадія життєвого циклу обов\'язкова',
        riskLevelRequired: 'Рівень ризику обов\'язковий',
        mainReasonsRequired: 'Потрібно вибрати хоча б одну основну причину',
        teamExpectationRequired: 'Очікування команди обов\'язкове',
        cultureAlignmentRequired: 'Відповідність культурі обов\'язкова',
        riskStatusRequired: 'Статус ризику обов\'язковий',
        assigneeRequired: 'Потрібно вибрати хоча б одного відповідального',
      },
      notifications: {
        createError: 'Не вдалося створити ризик',
        updateError: 'Не вдалося оновити ризик',
        noEmploymentPeriod: 'Для цього користувача не знайдено жодного трудового договору',
        employmentUpdateError: 'Не вдалося оновити трудовий договір',
      },
    },
    deleteDialog: {
      title: 'Видалити ризик',
      description: 'Ви впевнені, що хочете видалити ризик для "{{employeeName}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити ризик',
      },
    },
  },
  configurationPage: {
    pageConfig: {
      name: 'Конфігурація',
      label: 'Конфігурація',
    },
    tabs: {
      changeReasons: 'Причини змін',
      employeeStatuses: 'Статуси користувачів',
      alumni: 'Випускники',
      riskLevel: 'Рівень ризику',
      riskReason: 'Причина ризику',
      lifecycleStage: 'Стадія ЖЦ',
      expectation: 'Очікування',
      resolutionOutcome: 'Результат вирішення',
      riskStatus: 'Статус ризику',
    },
    statusesTitle: 'Статуси',
    riskReasonTypeOptions: {
      MAIN_REASON: 'Основна причина',
      SUB_REASON: 'Додаткова причина',
    },
  },
  alumniPage: {
    createButton: 'Створити випускника',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити випускника',
      editTitle: 'Редагувати випускника',
      text: 'Назва',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити випускника',
        updateError: 'Не вдалося оновити випускника',
      },
    },
    deleteDialog: {
      title: 'Видалити випускника',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити випускника',
      },
    },
  },
  riskLevelsPage: {
    createButton: 'Створити рівень ризику',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити рівень ризику',
      editTitle: 'Редагувати рівень ризику',
      text: 'Назва',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити рівень ризику',
        updateError: 'Не вдалося оновити рівень ризику',
      },
    },
    deleteDialog: {
      title: 'Видалити рівень ризику',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити рівень ризику',
      },
    },
  },
  riskReasonsPage: {
    createButton: 'Створити причину ризику',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      type: { headerName: 'Тип' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити причину ризику',
      editTitle: 'Редагувати причину ризику',
      text: 'Назва',
      type: 'Тип',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити причину ризику',
        updateError: 'Не вдалося оновити причину ризику',
      },
    },
    deleteDialog: {
      title: 'Видалити причину ризику',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити причину ризику',
      },
    },
  },
  lifecycleStagesPage: {
    createButton: 'Створити стадію ЖЦ',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити стадію ЖЦ',
      editTitle: 'Редагувати стадію ЖЦ',
      text: 'Назва',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити стадію ЖЦ',
        updateError: 'Не вдалося оновити стадію ЖЦ',
      },
    },
    deleteDialog: {
      title: 'Видалити стадію ЖЦ',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити стадію ЖЦ',
      },
    },
  },
  expectationsPage: {
    createButton: 'Створити очікування',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити очікування',
      editTitle: 'Редагувати очікування',
      text: 'Назва',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити очікування',
        updateError: 'Не вдалося оновити очікування',
      },
    },
    deleteDialog: {
      title: 'Видалити очікування',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити очікування',
      },
    },
  },
  resolutionOutcomesPage: {
    createButton: 'Створити результат вирішення',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити результат вирішення',
      editTitle: 'Редагувати результат вирішення',
      text: 'Назва',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити результат вирішення',
        updateError: 'Не вдалося оновити результат вирішення',
      },
    },
    deleteDialog: {
      title: 'Видалити результат вирішення',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити результат вирішення',
      },
    },
  },
  riskStatusesPage: {
    createButton: 'Створити статус ризику',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Назва' },
      color: { headerName: 'Колір' },
      actions: { headerName: 'Дії' },
    },
    editDialog: {
      createTitle: 'Створити статус ризику',
      editTitle: 'Редагувати статус ризику',
      text: 'Назва',
      color: 'Колір',
      textRequired: 'Назва обов\'язкова',
      notifications: {
        createError: 'Не вдалося створити статус ризику',
        updateError: 'Не вдалося оновити статус ризику',
      },
    },
    deleteDialog: {
      title: 'Видалити статус ризику',
      description: 'Ви впевнені, що хочете видалити "{{text}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити статус ризику',
      },
    },
  },
  changeReasonsPage: {
    pageConfig: {
      name: 'Причини змін',
      label: 'Причини змін',
    },
    filter: {
      scope: 'Сфера',
      status: 'Статус',
      scopeOptions: {
        STATUS: 'Статус',
        EMPLOYMENT_PERIOD: 'Зайнятість',
      },
    },
    columns: {
      id: { headerName: 'ID' },
      reasonName: { headerName: 'Причина' },
      color: { headerName: 'Колір' },
      scope: { headerName: 'Сфера' },
      actions: { headerName: 'Дії' },
    },
    changeTypeOptions: {
      VOLUNTARY: 'Добровільна',
      INVOLUNTARY: 'Недобровільна',
    },
    createButton: 'Створити причину',
    editDialog: {
      createTitle: 'Створити причину зміни',
      editTitle: 'Редагувати причину зміни',
      reasonName: 'Причина',
      statuses: 'Статуси',
      color: 'Колір',
      reasonNameRequired: 'Причина обов\'язкова',
      statusesRequired: 'Потрібно вибрати хоча б один статус',
      notifications: {
        createError: 'Не вдалося створити причину зміни',
        updateError: 'Не вдалося оновити причину зміни',
      },
    },
    deleteDialog: {
      title: 'Видалити причину зміни',
      description: 'Ви впевнені, що хочете видалити "{{reasonName}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити причину зміни',
      },
    },
  },
  projectsPage: {
    pageConfig: {
      name: 'Проєкти',
      label: 'Проєкти',
    },
    columns: {
      id: { headerName: 'ID' },
      name: { headerName: 'Назва' },
      status: { headerName: 'Статус' },
      employeeCount: { headerName: 'Співробітники' },
      startDate: { headerName: 'Дата початку' },
      endDate: { headerName: 'Дата завершення' },
      actions: { headerName: 'Дії' },
    },
    statusOptions: {
      PLANNED: 'Заплановано',
      ACTIVE: 'Активний',
      ON_HOLD: 'Призупинено',
      TERMINATED: 'Припинено',
      DELIVERED: 'Завершено',
    },
    deleteDialog: {
      title: 'Видалити проєкт',
      description: 'Ви впевнені, що хочете видалити проєкт "{{name}}"?',
      confirm: 'Видалити',
      notifications: {
        deleteError: 'Не вдалося видалити проєкт',
      },
    },
  },
  employeesList: {
    columns: {
      [EmployeeViewFields.id]: {
        headerName: 'ID'
      },
      [EmployeeViewFields.fullName]: {
        headerName: 'Прізвище та ім\'я'
      },
      [EmployeeViewFields.givenName]: {
        headerName: 'Ім\'я'
      },
      [EmployeeViewFields.familyName]: {
        headerName: 'Прізвище'
      },
      [EmployeeViewFields.email]: {
        headerName: 'Пошта'
      },
      [EmployeeViewFields.photoUrl]: {
        headerName: 'Образ'
      },
      [EmployeeViewFields.isArchived]: {
        headerName: 'Архівований'
      },
      [EmployeeViewFields.isAutoReportingEnabled]: {
        headerName: 'Автозвітування'
      },
      [EmployeeViewFields.status]: {
        headerName: 'Статус'
      },
      [EmployeeViewFields.tenure]: {
        headerName: 'Термін (років)'
      },
      [EmployeeViewFields.startDate]: {
        headerName: 'Дата початку'
      },
      [EmployeeViewFields.terminationDate]: {
        headerName: 'Дата звільнення'
      },
      [EmployeeViewFields.probationPeriodEndDate]: {
        headerName: 'Дата закінчення випробувального терміну'
      },
      [EmployeeViewFields.sex]: {
        headerName: 'Стать'
      },
      [EmployeeViewFields.dateOfBirth]: {
        headerName: 'Дата народження'
      },
      [EmployeeViewFields.careerStartDate]: {
        headerName: 'Дата початку кар\'єри'
      },
      [EmployeeViewFields.location]: {
        headerName: 'Країна/Місто'
      },
    }
  }
};
